import { ITextSnippetDTO } from '@modeso/types__aumico-lib-annualreport-be';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as fromTextSnippetActions from '../actions/text-snippet.action';
import { ANNUAL_REPORT_TEXT_SNIPPET_FEATURE_KEY } from '../constants/feature-state-key';
import type { ITextSnippetFeatureState } from '../interfaces/text-snippet-feature-state.interface';

export const SelectFeature = createFeatureSelector<ITextSnippetFeatureState>(ANNUAL_REPORT_TEXT_SNIPPET_FEATURE_KEY);

export const adapter: EntityAdapter<ITextSnippetDTO> = createEntityAdapter<ITextSnippetDTO>({
    selectId: selectTextSnippetId,
});

export const initialState: ITextSnippetFeatureState = adapter.getInitialState({
    selectedTextSnippet: null,
    error: undefined,
});

export function selectTextSnippetId(a: ITextSnippetDTO): string {
    return a._id;
}

const { selectAll } = adapter.getSelectors();

export const SelectAllTextSnippets = createSelector(SelectFeature, selectAll);

export const getSelectedTextSnippet = (state: ITextSnippetFeatureState) => state.selectedTextSnippet;

export const SelectSelectedTextSnippet = createSelector(SelectFeature, getSelectedTextSnippet);

export const TextSnippetReducer = createReducer(
    initialState,
    on(fromTextSnippetActions.CreateTextSnippet, (state) => ({
        ...state,
        error: undefined,
    })),
    on(fromTextSnippetActions.OnCreateTextSnippetSuccessfully, (state) => ({
        ...state,
        error: undefined,
    })),
    on(fromTextSnippetActions.OnCreateTextSnippetFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),

    on(fromTextSnippetActions.GetAllTextSnippets, (state) => ({
        ...state,
        error: undefined,
    })),
    on(fromTextSnippetActions.OnGetAllTextSnippetsSuccessfully, (state, action) => {
        return adapter.setAll(action.payload, { ...state, error: undefined });
    }),
    on(fromTextSnippetActions.OnGetAllTextSnippetsFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),

    on(fromTextSnippetActions.DeleteTextSnippets, (state) => ({ ...state, error: undefined })),
    on(fromTextSnippetActions.OnDeleteTextSnippetsSuccessfully, (state, action) => {
        return adapter.removeMany(action.textSnippetsIds, { ...state });
    }),
    on(fromTextSnippetActions.OnDeleteTextSnippetsFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),

    on(fromTextSnippetActions.UpdateTextSnippet, (state) => ({ ...state, error: undefined })),
    on(fromTextSnippetActions.OnUpdateTextSnippetSuccessfully, (state) => ({
        ...state,
        error: undefined,
    })),
    on(fromTextSnippetActions.OnUpdateTextSnippetFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),

    on(fromTextSnippetActions.GetTextSnippetById, (state) => ({ ...state, error: undefined })),
    on(fromTextSnippetActions.OnGettingTextSnippetByIdSuccessfully, (state, action) => ({
        ...state,
        selectedTextSnippet: action.payload,
        error: undefined,
    })),
    on(fromTextSnippetActions.OnGettingTextSnippetByIdFailed, (state, action) => ({
        ...state,
        selectedTextSnippet: null,
        error: action.payload,
    })),
    on(fromTextSnippetActions.ResetSelectedTextSnippet, (state) => ({
        ...state,
        selectedTextSnippet: null,
    })),
);
